import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { baseGridItemGridProps } from "@store/theme/common/props/baseGrid";
import { css } from "styled-components";

Object.assign(cardContainerMultiColumnStyles, {
    gridItem: {
        ...baseGridItemGridProps.item,
        css: css`
            ${baseGridItemGridProps.item?.css}
            align-items: stretch;
        `,
    },
    cardDivider: {
        css: css`
            display: flex;
            width: 100%;
        `,
    },
});
